import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces(['common', 'navigation']);

export type NavigationConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};
export const navigationConfig: NavigationConfig = {
  i18nNamespaces,
};
